import React from "react";
import { UserStationExpirationTemplate } from "themes/administration/user/components";

function UserStationExpiration(props) {
    return <UserStationExpirationTemplate {...props} />;
}

export default UserStationExpiration;
